import { ItemToggleList } from '../../../components/shared/ItemToggleList';
import { useMenuEnabledFn } from '../../../lib/menu-gate';
import type { WidgetSettings } from '../../../store/dashboardStore';
import {
  QUICK_LINK_DESC, moveQuickLink, quickLinkRows, toggleQuickLink,
} from './quick-link-order';

/**
 * 위젯 설정 v2 · 빠른 실행 — 「바로가기 고르기 · 지금 있는 기능」 (2026-09-16 · 대시보드 시안 v2 V4).
 *
 * 캡처: `_workspace/design-dashboard-v2/widget-settings-quick-launch.png`.
 * ★ v2 설정 창에서만 쓴다 — 옛 설정 창은 종전 체크박스 고르개(`WidgetOwnSettings`) 그대로다.
 * ★ 켜기 · 끌기+키보드 순서 · 메뉴 꺼짐 막힘은 `ItemToggleList` 와 `quick-link-order.ts` 가 한다.
 */
export function QuickLinkOrderField({
  value, onChange,
}: {
  value: WidgetSettings;
  onChange: (patch: WidgetSettings) => void;
}) {
  const menuEnabled = useMenuEnabledFn();
  const rows = quickLinkRows(value.quickLinks, menuEnabled);
  const onCount = rows.filter((r) => r.on && !r.lockedReason).length;

  return (
    <div className="wsv2-field">
      <span className="wsv2-label">바로가기 · 켠 {onCount}개가 손잡이 순서대로 보입니다</span>
      <ItemToggleList
        ariaLabel="바로가기"
        items={rows.map((r) => ({
          key: r.key,
          label: r.label,
          labelText: r.label,
          description: QUICK_LINK_DESC[r.key],
          on: r.on,
          lockedReason: r.lockedReason,
        }))}
        onToggle={(key, next) => onChange({ quickLinks: toggleQuickLink(value.quickLinks, key, next) })}
        onMove={(from, to) => {
          const next = moveQuickLink(value.quickLinks, from, to);
          if (next) onChange({ quickLinks: next });
        }}
      />
    </div>
  );
}
